import React from 'react';

import './sessionTimeoutModal.scss';

import PropTypes from 'prop-types';
import {ModalDialog} from '@elixir/components';

export class SessionTimeoutModal extends React.Component {

    static contextTypes = {
        title: PropTypes.string,
        message: PropTypes.number,
        actionHandler: PropTypes.func,
        translator: PropTypes.func
    };

    constructor (props) {
        super(props);
        this.state = {count: 10};

        this.onTimerTick = this.onTimerTick.bind(this);
        this.onAction = this.onAction.bind(this);
        this.onCancel = this.onCancel.bind(this);
    }

    componentWillMount () {
        this.countdownWarningLabel = this.context.translator('session.warning.coundownMessage');
    }

    componentDidMount () {
        this.interval = setInterval(this.onTimerTick, 1000);
    }

    onTimerTick () {
        this.setState({count: this.props.getRemainingTime()})
    }

    componentWillUnmount () {
        clearInterval(this.interval);
    }

    onAction () {
        this.props.onAction();
    }

    onCancel () {
        this.props.onCancel();
    }

    render () {
        const {
            title,
            message,
            actionButtonLabel
        } = this.props;

        const {
            count
        } = this.state;

        return (
            <ModalDialog
                className="actionConfirmationModal"
                onAction={this.onAction}
                onCancel={this.onCancel}
                showCancelBtn={false}
                showSaveBtn={false}
                cancelBtnLabel={''}
                saveBtnLabel={''}
                actionBtnLabel={actionButtonLabel}
                title={title}
                centerTitle={false}>
                {message} {this.countdownWarningLabel.replace('{$1}', `${parseInt(count / 60)}:${this.state.count % 60}`)}
            </ ModalDialog>
        );
    }
}


